import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form, Col, Row, Spinner } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = "https://crm.fazoacademy.in/php/career.php";

function Career({ onLogout, role }) {
    const [courses, setCourses] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [editCourse, setEditCourse] = useState({
        id: null,
        title: "",
        role: "",
        experience: "",
        location: "",
        jd1: "", jd2: "", jd3: "", jd4: "", jd5: "",
        jd6: "",

        skill1: "", skill2: "", skill3: "", skill4: "",
        skill5: "", skill6: "",

        types: "",
    });


    const [formData, setFormData] = useState({
        title: "",
        role: "",
        experience: "",
        location: "",
        jd1: "", jd2: "", jd3: "", jd4: "", jd5: "",
        jd6: "",

        skill1: "", skill2: "", skill3: "", skill4: "",
        skill5: "", skill6: "",

        types: "",
    });

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        setLoading(true);
        try {
            const response = await axios.get(API_URL);
            const jsonString = response.data.substring(response.data.indexOf("["));
            const parsedData = JSON.parse(jsonString);
            setCourses(Array.isArray(parsedData) ? parsedData : []);
        } catch (error) {
            console.error("Error fetching courses:", error);
            setCourses([]);
        }
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddCourse = async () => {
        const trimmedData = Object.fromEntries(
            Object.entries(formData).map(([key, val]) => [key, val.trim()])
        );

        if (!trimmedData.title || !trimmedData.role || !trimmedData.experience || !trimmedData.location) {
            Swal.fire({
                icon: "warning",
                title: "Missing Fields",
                text: "Please fill all required fields",
            });
            return;
        }

        try {
            await axios.post(API_URL, trimmedData);
            fetchCourses();
            setFormData({
                title: "", role: "", experience: "", location: "",
                jd1: "", jd2: "", jd3: "", jd4: "", jd5: "",
                jd6: "",
                skill1: "", skill2: "", skill3: "", skill4: "",
                skill5: "", skill6: "", types: ""
            });
            setShowAddModal(false);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Details added successfully!",
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error("Error adding details:", error);
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Failed to add details.",
            });
        }
    };

    // Edit Course
    const handleEditCourse = async () => {
        

            try {
                await axios.put(`${API_URL}/${editCourse.id}`, editCourse); // Include course ID

                fetchCourses();
                setShowEditModal(false);
                Swal.fire({
                    icon: "success",
                    title: "Updated!",
                    text: "Course updated successfully!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            } catch (error) {
                console.error("Error updating course:", error);
                Swal.fire({ icon: "error", title: "Oops!", text: "Failed to update course." });
            }
        
    };




    const handleDeleteCourse = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${API_URL}?id=${id}`);
                    fetchCourses();
                    Swal.fire("Deleted!", "Details deleted successfully.", "success");
                } catch (error) {
                    console.error("Delete error:", error);
                    Swal.fire("Error", "Failed to delete", "error");
                }
            }
        });
    };
    const filteredCourses = courses.filter((course) => {
        const query = searchQuery.toLowerCase();

        // Collect skills into an array
        const skills = [
            course.skill1,
            course.skill2,
            course.skill3,
            course.skill4,
            course.skill5,
            course.skill6
        ].filter(Boolean); // removes null/undefined

        // Collect JDs into an array
        const jds = [
            course.jd1,
            course.jd2,
            course.jd3,
            course.jd4,
            course.jd5,
            course.jd6
        ].filter(Boolean);

        return (
            course.title.toLowerCase().includes(query) ||
            course.role.toLowerCase().includes(query) ||
            course.experience.toLowerCase().includes(query) ||
            course.location.toLowerCase().includes(query) ||
            skills.some(skill => skill.toLowerCase().includes(query)) ||
            jds.some(jd => jd.toLowerCase().includes(query)) ||
            course.types.toLowerCase().includes(query)

        );
    });


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="course-container">
            <div className="navigation">
                <a href="#">Job Assist</a> / <a href="#" onClick={onLogout}>Logout</a>
            </div>

            <div className="add-course">
                <button onClick={() => setShowAddModal(true)} className="add-btn">Add new details +</button>
            </div>

            <div className="d-flex justify-content-between align-items-center my-2">
                <Form.Select
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    className="pagination-select w-auto"
                >
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                </Form.Select>

                <Form.Control
                    type="text"
                    placeholder="Search title..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input w-25"
                />
            </div>

            {loading ? (
                <div className="text-center my-4">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : (
                <Table striped bordered hover responsive className="course-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Title</th>
                            <th>Role</th>
                            <th>Experience</th>
                            <th>Location</th>
                            <th>Job Description</th>
                            <th>Skills Need</th>
                            <th>Job Post For</th>
                            {role === 'admin' && (
                                <th>Actions</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {currentCourses.length === 0 ? (
                            <tr>
                                <td colSpan="8" className="text-center text-danger">No details found</td>
                            </tr>
                        ) : (
                            currentCourses.map((course, index) => (
                                <tr key={course.id}>
                                    <td>{indexOfFirstItem + index + 1}</td>
                                    <td>{course.title}</td>
                                    <td>{course.role}</td>
                                    <td>{course.experience}</td>
                                    <td>{course.location}</td>
                                    <td>
                                        {[...Array(6)].map((_, i) => {
                                            const value = course[`jd${i + 1}`];

                                            return value ? (
                                                <div key={i}>
                                                    {i + 1}. {value}
                                                </div>
                                            ) : null;
                                        })}
                                    </td>

                                    <td>

                                        {[...Array(6)].map((_, i) => {
                                            const value = course[`skill${i + 1}`];

                                            return value ? (
                                                <div key={i}>
                                                    {i + 1}. {value}
                                                </div>
                                            ) : null;
                                        })}
                                    </td>
                                    <td>{course.types}</td>
                                    {role === 'admin' && (
                                        <td>
                                            <FaEdit
                                                className="edit-icon"
                                                onClick={() => {
                                                    setEditCourse(course);
                                                    setShowEditModal(true);
                                                }}
                                            />
                                            <FaTrash
                                                className="text-danger cursor-pointer"
                                                onClick={() => handleDeleteCourse(course.id)} />
                                        </td>

                                    )}

                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            )}

            <div className="pagination-controls d-flex justify-content-center align-items-center gap-3 my-3">
                <Button
                    variant="secondary"
                    onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                >
                    Previous
                </Button>
                <span className="page-number">Page {currentPage}</span>
                <Button
                    variant="secondary"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={indexOfLastItem >= filteredCourses.length}
                >
                    Next
                </Button>
            </div>

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {["title", "role", "experience", "location"].map((field, idx) => (
                            <Form.Group as={Row} className="mb-2" key={field}>
                                <Form.Label column sm={3}>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        type="text"
                                        name={field}
                                        value={formData[field]}
                                        onChange={handleChange}
                                        placeholder={`Enter ${field}`}
                                    />
                                </Col>
                            </Form.Group>
                        ))}

                        <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
                            <Form.Label column sm={3}>Job Posting For</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    as="select"
                                    name="types"
                                    value={formData.types}
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    <option value="Triplette">Triplette</option>
                                    <option value="Redite">Redite</option>

                                </Form.Control>
                            </Col>
                        </Form.Group>

                        {[...Array(6)].map((_, i) => (
                            <Form.Group as={Row} className="mb-2" key={`jd${i + 1}`}>
                                <Form.Label column sm={3}>{`JD${i + 1}`}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        name={`jd${i + 1}`}
                                        value={formData[`jd${i + 1}`]}
                                        onChange={handleChange}
                                        placeholder={`Enter Job Description ${i + 1}`}
                                    />
                                </Col>
                            </Form.Group>
                        ))}

                        {[...Array(6)].map((_, i) => (
                            <Form.Group as={Row} className="mb-2" key={`skill${i + 1}`}>
                                <Form.Label column sm={3}>{`Skill${i + 1}`}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                       as="textarea"
                                        rows={4}
                                        name={`skill${i + 1}`}
                                        value={formData[`skill${i + 1}`]}
                                        onChange={handleChange}
                                        placeholder={`Enter Skill ${i + 1}`}
                                    />
                                </Col>
                            </Form.Group>
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
                    <Button variant="success" onClick={handleAddCourse}>Add Details</Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Course</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {["title", "role", "experience", "location"].map((field, idx) => (
                            <Form.Group as={Row} className="mb-2" key={field}>
                                <Form.Label column sm={3}>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        type="text"
                                        name={field}
                                        value={editCourse[field]}
                                        onChange={(e) => setEditCourse({ ...editCourse, [field]: e.target.value })}
                                        placeholder={`Enter ${field}`}

                                    />
                                </Col>
                            </Form.Group>
                        ))}
                        <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
                            <Form.Label column sm={3}>Job Posting For</Form.Label>

                            <Col sm={9}>
                                <Form.Control
                                    as="select"
                                    name="types"
                                    value={editCourse.types || ""}
                                    onChange={(e) =>
                                        setEditCourse({
                                            ...editCourse,
                                            types: e.target.value
                                        })
                                    }
                                >
                                    <option value="">Select</option>
                                    <option value="triplette">Triplette</option>
                                    <option value="redite">Redite</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>


                        {[...Array(6)].map((_, i) => (
                            <Form.Group as={Row} className="mb-2" key={`jd${i + 1}`}>
                                <Form.Label column sm={3}>{`JD${i + 1}`}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        // type="text"
                                        as="textarea"
                                        rows={5}
                                        name={`jd${i + 1}`}
                                        value={editCourse[`jd${i + 1}`]}
                                        onChange={(e) =>
                                            setEditCourse({
                                                ...editCourse,
                                                [`jd${i + 1}`]: e.target.value
                                            })
                                        } placeholder={`Enter Job Description ${i + 1}`}
                                    />
                                </Col>
                            </Form.Group>
                        ))}

                        {[...Array(6)].map((_, i) => (
                            <Form.Group as={Row} className="mb-2" key={`skill${i + 1}`}>
                                <Form.Label column sm={3}>{`Skill${i + 1}`}</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name={`skill${i + 1}`}
                                        value={editCourse[`skill${i + 1}`]}
                                          onChange={(e) =>
                                            setEditCourse({
                                                ...editCourse,
                                                [`skill${i + 1}`]: e.target.value
                                            })
                                        }
                                        placeholder={`Enter Skill ${i + 1}`}
                                    />
                                </Col>
                            </Form.Group>
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary"
                        onClick={handleEditCourse}
                    >
                        Update Course
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default Career;
